module.exports = __webpack_public_path__ + "img/mini-menu-pc.0d82087e.svg";